import { getAvatarColor, getInitial } from '../../utils/avatarColor'

interface UserAvatarProps {
  name: string
  photoUrl?: string
  size?: 'sm' | 'md' | 'lg'
  onClick?: () => void
}

const SIZES = {
  sm: 32,
  md: 40,
  lg: 64,
}

export function UserAvatar({ name, photoUrl, size = 'md', onClick }: UserAvatarProps) {
  const pixelSize = SIZES[size]
  const backgroundColor = getAvatarColor(name)
  const initial = getInitial(name)

  const containerStyles: React.CSSProperties = {
    width: `${pixelSize}px`,
    height: `${pixelSize}px`,
    borderRadius: '50%',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: photoUrl ? 'transparent' : backgroundColor,
    color: 'white',
    fontSize: `${pixelSize * 0.45}px`,
    fontWeight: 600,
    cursor: onClick ? 'pointer' : 'default',
    border: 'none',
    padding: 0,
    flexShrink: 0,
    userSelect: 'none',
  }

  const imageStyles: React.CSSProperties = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  }

  // Ensure touch target is at least 44x44px
  const wrapperStyles: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '44px',
    minHeight: '44px',
    cursor: onClick ? 'pointer' : 'default',
  }

  const content = photoUrl ? (
    <img src={photoUrl} alt={name} style={imageStyles} />
  ) : (
    <span aria-hidden="true">{initial}</span>
  )

  if (onClick) {
    return (
      <div style={wrapperStyles}>
        <button
          type="button"
          style={containerStyles}
          onClick={onClick}
          aria-label={`${name}'s profile menu`}
          aria-haspopup="menu"
        >
          {content}
        </button>
      </div>
    )
  }

  return (
    <div style={wrapperStyles}>
      <div style={containerStyles} aria-label={name} role="img">
        {content}
      </div>
    </div>
  )
}
